import moment from 'moment'
import api from '@/api/entry'
import store from '@/store'
import { Dialog } from 'vant'

/**
 * todo 取消订阅
 */
const cancelOrderRetailGoods = (orderId) => {
  let params = {
    orderId
  }
  return new Promise((resolve, reject) => {
    api.userCentered.cancelOrderRetailGoods(params).then((res) => {
      let { status } = res
      if (status) {
        resolve()
      } else {
        reject()
      }
    })
  })
}

/**
 * todo 拉取商品的订阅信息，查看有没有订阅过 拦截
 */
const getRetailGoodsSubscribeOrderInfo = (route) => {
  let params = { goodsId: route.query.id }
  return new Promise((resolve, reject) => {
    api.goodList.getRetailGoodsSubscribeOrderInfo(params).then((res) => {
      let { result } = res
      if (result && result.mainOrder) {
        store.dispatch('newsKiosk/updateActionOrderInfo', result)
        resolve(result)
      } else {
        store.dispatch('newsKiosk/updateActionOrderInfo', null)
        reject()
      }
    })
  })
}

// 导出
export const subscribeDetail = {
  data() {
    return {
      goodsInfo: {
        name: '人民日报（零售）',
        price: '周一至周五 ￥1.80 <br />周六、周日、法定节假日 ￥0.60',
        explain: '支持购买当日和预售7日的报纸，不支持退款，客服电话 <a href="tel:010-65368820">010-65368820</a>',
        count: 1
      },
      // 用户信息
      userInfo: {
        userName: '',
        phone: '',
        address: ''
      },
      // 外链列表
      originHrefData: [
        { id: '362', name: '环球时报（全年）', url: 'https://shop110201281.m.youzan.com/v2/showcase/homepage?alias=eKvx8FeOWw&is_info_changed=1&is_silence_auth=1', message: '' },
        { id: '549', name: '中国城市报（全年）', url: '', message: '如需订阅，请咨询010-65367136' },
        {
          id: '391',
          name: '中国能源报（全年）',
          url: 'http://mp.weixin.qq.com/s?__biz=MjM5NTI4MTIyMg==&mid=2657989911&idx=1&sn=93257079d69730d6ad6419d4c1dac0e3&chksm=bd63f53e8a147c28bc751ff775a817c4094536ed51f5623dd269dd85c10a53ceaacc80c37507&mpshare=1&scene=1&srcid=0808azFxel5e581vL1LLPrQv&sharer_shareinfo=17a44d0d13aa06d5455a52563d5b7354&sharer_shareinfo_first=17a44d0d13aa06d5455a52563d5b7354#rd',
          message: ''
        },
        { id: '548', name: '中国汽车报（全年）', url: 'https://mall.11185.cn/h5/#/bkGoodsDetails?spuId=100830&from=imgShare&dsId=zxSWChat&dsModule=1097bdf0-fff0-a022-056f-7fbf932244fe', message: '' },
        { id: '360', name: '健康时报（全年）', url: 'https://mall.11185.cn/h5/#/bkGoodsDetails?spuId=101027', message: '' },
        { id: '550', name: '人民论坛（全年）', url: '', message: '如需订阅，请咨询010-65369882' },
        { id: '551', name: '学术前沿（全年）', url: '', message: '如需订阅，请咨询010-65369882' },
        { id: '552', name: '国家治理（全年）', url: '', message: '如需订阅，请咨询010-65369882' },
        { id: '445', name: '环球人物（全年）', url: 'https://tuicashier.youzan.com/pay/wscgoods_order?alias=3nvin1vtnf3vklc', message: '' },
        { id: '554', name: '新安全（全年）', url: 'https://mall.11185.cn/h5/#/bkGoodsDetails?spuId=32395067&saleManId=null&from=imgShare', message: '' },
        { id: '553', name: '平安校园（全年）', url: 'https://mall.11185.cn/h5/#/bkGoodsDetails?spuId=33014133&saleManId=null&from=imgShare', message: '' },
        {
          id: '365',
          name: '中国经济周刊（全年）',
          url: 'https://shop43706194.m.youzan.com/wscshop/showcase/feature?alias=z6Fqaccv5j&kdt_id=43514026',
          message: ''
        },
        {
          id: '361',
          name: '国家人文历史（全年）',
          url: 'https://h5.youzan.com/wscgoods/detail/2funigrl70y2zu9?scan=1&activity=none&from=kdt&qr=directgoods_3379213412&shopAutoEnter=1&alias=2funigrl70y2zu9&is_share=1&from_uuid=19972080787&goodsImg=https%3A%2F%2Fimg.yzcdn.cn%2Fupload_files%2F2024%2F10%2F10%2FFiZtck_zF3rQCJjEa-I3sk63QLk_.jpg&sf=wx_sm&share_cmpt=native_wechat',
          message: ''
        },
        { id: '382', name: '生命时报（全年）', url: 'https://shop14210741.m.youzan.com/wscgoods/detail/2xlc82kjzg5t9wq', message: '' },
        { id: '363', name: '讽刺与幽默（全年）', url: 'https://mall.11185.cn/h5/#/bkGoodsDetails?spuId=101046&from=imgShare&dsId=zxSWChat&dsModule=5b0c12fe-792a-aa0b-beb9-51e34cbbeda5', message: '' },
        { id: '379', name: '民生周刊（全年）', url: '', message: '如需订阅，请咨询010-65368279' },
        { id: '358', name: '证券时报（全年）', url: '', message: '如需订阅，请咨询0755-83501737' },
        { id: '413', name: '人民日报海外版（全年）', url: '', message: '如需订阅，请咨询010-65369416' },
        { id: '555', name: '记忆里的“两弹一星”+经典号外文创组合装', url: 'https://item.jd.com/10121487094152.html?sdx=ehi-lLxFuZiE6JnJY4JYhMEguTSQDQkrsm1Iua1MZ5H7cJjSIphU5H7hoE7mXw', message: '' },
        {
          id: '558',
          name: '人民日报写作课：魔鬼与细节、学会断舍离、写出高级感（全3册）',
          url: 'https://item.jd.com/10067816721695.html?sdx=ehi-lLxFuZiE6JnIZ4RUjcAnsjGXAQ4rsm1Iua1MZ5H7cJjSIphU5H_mrE3iVA',
          message: ''
        },
        {
          id: '557',
          name: '好新闻的魅力+好新闻的气质+好新闻的样子+好新闻的味道（套装）',
          url: 'https://item.jd.com/10102049944904.html?sdx=ehi-lLxFuZiE6JnJYYFciM8ptDSYCA8rsm1Iua1MZ5H7cJjSIphU5nvhoEHjVA',
          message: ''
        },
        {
          id: '556',
          name: '人民日报评论年编（2023）人民论坛、人民时评、人民观点、评论员观察',
          url: 'https://item.jd.com/10097459351952.html?sdx=ehi-lLxFuZiE6JnIaIRYic8jtTGYDQkrsm1Iua1MZ5H7cJjSIphU5HzlpkjrUg',
          message: ''
        }
        // { name: '新闻战线', url: '', message: '' }
      ]
    }
  },
  beforeRouteEnter(to, from, next) {
    // 非零售 直接过
    if (Number.parseInt(to.query.typeId) !== 4) {
      next(true)
      return
    }

    // 来自于提交订单页 就取消订阅
    let orderId = JSON.parse(window.sessionStorage.getItem('orderId'))
    if (from.name === 'SubmitOrder' && orderId) {
      cancelOrderRetailGoods(orderId).then(() => {
        getRetailGoodsSubscribeOrderInfo(to)
          .then((res) => {
            let { mainOrder } = res
            let query = { orderId: mainOrder.orderId }
            next({ path: '/submitOrder', query })
          })
          .catch(() => {
            next(true)
          })
      })
      return
    }

    /**
     * todo 拦截 是否订阅过  零售
     */
    getRetailGoodsSubscribeOrderInfo(to)
      .then((res) => {
        let { mainOrder } = res
        let query = { orderId: mainOrder.orderId }
        next({ path: '/submitOrder', query })
      })
      .catch(() => {
        next(true)
      })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'NewspapersAndPeriodicalsList') {
      this.$store.dispatch('newsKiosk/updateActionDateList', [])
    }
    next(true)
  },
  computed: {
    getStockInfo() {
      return (day) => {
        return this.stockInfo[moment(day).format('YYYY-MM-DD')]
      }
    },
    greaterThanToday() {
      return (day) => {
        let date = moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        return day.getTime() > date.valueOf()
      }
    }
  },
  methods: {
    moment,
    /**
     * todo 日历格式化数据方法
     */
    calendarFormat(day) {
      if (this.getStockInfo(day.date) && this.getStockInfo(day.date).holidayType) {
        day.className = `holiday`
      }
      return day
    },
    /**
     * todo 拉取商品详情
     */
    detail(id) {
      this.$api.goodList.detail({ id }).then((res) => {
        let { result } = res
        if (result && JSON.stringify(result) !== '{}') {
          let { picPath, goodsName, price, goodsDesc, priceHoliday, typeId, id } = result
          // 通过url参数赋值
          Object.assign(this, {
            typeId: Number.parseInt(typeId),
            goodImage: picPath,
            goodsId: id,
            price,
            goodsInfo: {
              name: goodsName,
              price: priceHoliday && JSON.parse(priceHoliday) ? `周一至周五 ￥${price} <br />周六、周日、法定节假日 ￥${priceHoliday}` : `￥${price}`,
              explain: goodsDesc,
              count: 1
            }
          })
        }
      })
    },
    /**
     * todo 获取零售商品及库存信息 日历内容回显
     */
    retailGoodsStock() {
      let params = { goodsId: this.goodsId }
      return new Promise((resolve, reject) => {
        this.$api.goodList.retailGoodsStock(params).then((res) => {
          let { result } = res
          if (result && Object.getOwnPropertyNames(result).length) {
            this.stockInfo = result.stockInfo
            let range = Object.keys(result.stockInfo)
            if (range) {
              this.minStock = new Date(range[0])
              this.maxStock = new Date(range[range.length - 1])
            }
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    /**
     * todo 打开日历
     */
    chooseDate() {
      // 零售 拉取日历列表
      this.retailGoodsStock().then(() => {
        this.calendarShow = true
        // this.calendarDafaultDate = [moment().toDate()]
      })
    },
    /**
     * todo 删除订阅日期
     */
    deleDate({ date }) {
      if (this.$store.state.newsKiosk.dateList.length < 2) {
        this.$toast('商品数量不能为空！')
        return
      }
      this.$store.dispatch(
        'newsKiosk/updateActionDateList',
        this.$store.state.newsKiosk.dateList.filter((item) => item.date !== date)
      )
    },
    /**
     * todo 是否关注
     */
    checkUserSubscribe() {
      this.$api.user.checkUserSubscribe().then((res) => {
        let { count, result } = res
        if (count > 0) {
          this.submitOrder()
        } else {
          Dialog.alert({
            message: result
          }).then(() => {
            // on close
          })
        }
      })
    },
    /**
     * todo 立即订阅
     */
    submitOrder() {
      let { id, typeId, goodsName, price } = this.$route.query
      let { count, name } = this.goodsInfo

      // 外链拦截
      if (this.originHrefData.some((i) => i.name === name)) {
        if (this.originHrefData.find((i) => i.name === name)?.url) {
          window.location.href = this.originHrefData.find((i) => i.name === name).url
          return
        }
        if (this.originHrefData.find((i) => i.name === name)?.message) {
          Dialog.alert({ message: this.originHrefData.find((i) => i.name === name).message })
          return
        }
      }

      // 零售拦截
      if (this.typeId == 4) {
        // 没有选择商品提示
        if (!this.$store.state.newsKiosk.dateList.length) {
          this.$toast('请选择日期和数量')
          return
        }
        // 有超过库存的数量限制提交
        if (this.$store.state.newsKiosk.dateList.some((date) => date.verify)) {
          return
        }
      }

      // this.orderRetailGoods()
      this.getWxConfig().then((res) => {
        let { userName, telNumber, postalCode, provinceName, cityName, countryName, detailInfo, nationalCode } = res
        this.userInfo = { userName, phone: telNumber, postalCode, provinceName, cityName, countryName, address: detailInfo, nationalCode }

        // 非零售存到本地 没有订阅
        window.localStorage.setItem('addressInfo', JSON.stringify(this.userInfo))

        // 零售
        if (this.typeId == 4) {
          // 提交订阅
          this.orderRetailGoods()
        } else {
          this.$router.push({
            path: '/submitOrder',
            query: { goodsId: this.goodsId, goodsNumber: count, typeId: this.typeId, goodsName: this.goodsInfo.name, price: this.price, goodImage: this.goodImage }
          })
        }
      })
    },
    /**
     * todo 拉取微信配置信息接口
     * @param {url: 当前全部地址，包括参数}
     */
    getWxConfig() {
      let _this = this
      // 获取 userInfo 包括 用户信息 手机号 地址相关
      return new Promise((resolve, reject) => {
        // 配置微信
        const wxApi = (data) => {
          window.wx.config({
            debug: false,
            appId: data.appId,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['checkJsApi', 'openAddress', 'editAddress']
          })
          window.wx.ready(function () {
            window.wx.openAddress({
              success: function (res) {
                resolve(res)
              },
              cancel(errMsg) {
                reject(errMsg)
              }
            })
          })

          window.wx.error(function (res) {
            _this.$toast(res.errMsg)
            reject(res.errMsg)
          })
        }

        // 如果是ios直接从本地读取注册信息
        if (/iPhone|mac|iPod|iPad|ios/gi.test(navigator.userAgent)) {
          let result = JSON.parse(window.sessionStorage.getItem('wxc'))
          wxApi(result)
        } else {
          // let {} = this.$route.query
          let url = ''
          Object.keys(this.$route.query).forEach((key) => {
            if (key !== 'goodsDesc') {
              url += `&${key}=${this.$route.query[key]}`
            }
          })
          // 安卓正常拉取微信配置信息
          this.$api.user.getWxConfig({ url: window.location.href }).then((res) => {
            let { result } = res
            if (JSON.stringify(result) !== '{}') {
              wxApi(result)
            }
          })
        }
      })
    },
    /**
     * todo 立即订阅接口调用
     */
    orderRetailGoods() {
      let { id } = this.$route.query
      // 订阅日期列表
      let orderInfo = {}
      this.$store.state.newsKiosk.dateList.forEach((item) => {
        orderInfo[item.date + ' 00:00:00'] = item.number
      })
      let params = {
        goodsId: id,
        orderInfo,
        ...this.userInfo
      }
      this.$api.goodList
        .orderRetailGoods(params)
        .then((res) => {
          let { result, message, status } = res
          if (status) {
            this.$store.dispatch('newsKiosk/updateActionOrderId', result.orderId)
            this.$router.push({ path: '/submitOrder', query: { orderId: result.orderId, goodImage: this.goodImage } })
            window.sessionStorage.setItem('orderId', result.orderId)
          } else {
            // let { stockcount, saledate } = result.stockNoEnough || {}
            this.$toast(message)
            this.$store.dispatch('newsKiosk/updateActionDateListVerify', result.stockNoEnough || {})
            // 查询后的库存不足
            // this.$store.state.newsKiosk.dateList.forEach((date) => {
            //   if (date.date === saledate) {
            //     date.verify = true
            //     date.stockNum = stockcount
            //   }
            // })
          }
        })
        .catch((err) => {
          this.$toast(err)
        })
    },
    /**
     * todo 关闭日历
     */
    closeCalendar() {
      // 关闭日历
      this.calendarShow = false
    },
    /**
     * todo 选择日历范围后
     */
    chooseConfirmDate(dateArray) {
      // let dateArray = this.$refs.calendar.currentDate
      // if (!dateArray[1]) {
      //   dateArray[1] = dateArray[0]
      // }
      let dateList = dateArray
        .map((item) => moment(item).format('YYYY-MM-DD'))
        .sort((a, b) => {
          let aValue = moment(a).valueOf()
          let bValue = moment(b).valueOf()
          if (aValue > bValue) {
            return 1
          } else if (aValue < bValue) {
            return -1
          } else {
            return 0
          }
        })
      // for (let index = dateArray[0].getTime(); index <= dateArray[1].getTime(); ) {
      //   dateList.push(moment(index).format('YYYY-MM-DD'))
      //   index = index + 1 * 24 * 60 * 60 * 1000
      // }
      this.$store.dispatch(
        'newsKiosk/updateActionDateList',
        dateList
          .map((item) => {
            return this.stockInfo[item] ? { ...this.stockInfo[item], verify: false, date: item, number: 1, disableMinus: false } : undefined
          })
          .filter((i) => i)
      )
      // 关闭日历 塞值
      this.calendarShow = false
      this.calendarDafaultDate = dateList.map((item) => moment(item).toDate())
    },
    /**
     * todo 选择数量验证
     */
    changeNumber(row) {
      if (row.number === '') {
        return
      }
      row.verify = row.number > row.stockNum
      if (row.number < 1) {
        const dateList = this.$store.state.newsKiosk.dateList
        if (dateList.length < 2) {
          this.$toast('商品数量不能为空！')
          return
        }
        this.$nextTick(() => {
          this.$store.dispatch(
            'newsKiosk/updateActionDateList',
            dateList.filter((item) => item.date !== row.date)
          )
          this.calendarDafaultDate = dateList.filter((item) => item.date !== row.date).map((item) => moment(item.date).toDate())
        })
      }
    }
  }
}
